import '../../../styles/templates/customers/account.scss';
import { InitAccountMenu } from '../_shared/ui-components/Account/AccountMenu';

window.addEventListener('DOMContentLoaded', () => {
  InitAccountMenu();
});
